<template>
  <a-modal
    :visible="isShareVisible"
    :maskClosable="false"
    :title="$t('project.sandboxShare')"
    :bodyStyle="{'padding-top': '20px', 'bottom-bottom': '24px'}"
    :footer="false"
    width="30%"
    @cancel="handleCancel">
    <div class="shareSands">
      <a-row class="shareRow">
        <div class="shareTitle">
          <a-icon type="share-alt" />
        </div>
        <div class="share-content">
          <a-select v-model="category" @change="onCategoryChange" class="share-select">
            <a-select-option
              v-for="item in categoryList"
              :key="item.value"
              :value="item.value"
              >{{ $t(item.name) }}</a-select-option
            >
          </a-select>
        </div>
      </a-row>
      <a-row v-if="category === 1" class="shareRow">
        <div class="shareTitle">
          {{$t('project.content')}}
        </div>
        <div class="share-content">
          <a-tree-select
            style="width: 100%;"
            v-model="selected"
            :treeData="treeData"
            :placeholder="$t('project.selectShareWholeProjectOrPage')"
            multiple
            tree-checkable
            :show-checked-strategy="SHOW_ALL"
            treeNodeFilterProp="name"
            :replaceFields="{ title:'name',value: 'id' }"
            @change="handSelectTreeChange"
          >
            <!-- <a-tree-select-node v-for="item in treeData" :key="item.id" :value="item.id" :title="item.name">
            </a-tree-select-node> -->
          </a-tree-select>
        </div>
      </a-row>
      <a-row class="shareRow">
        <div class="shareTitle"></div>
        <div class="share-content">
          <a-row class="shareRow">
            <a-col :span="8">
              <a-checkbox
                v-model="needPwd"
                @change="handNeedPwd"
                >{{$t('project.enablePassword')}}</a-checkbox
              >
            </a-col>
            <a-col :span="16" v-if="needPwd">
              <a-row class="passwordRow">
                <a-col :span="7" style="text-align:right;padding-right: 8px;">{{$t('base.password')}}</a-col>
                <a-col :span="17">
                  <a-input v-model="password" disabled />
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </div>
      </a-row>
      <a-row class="shareRow">
        <div class="shareTitle">
          {{$t('project.expirationTime')}}
        </div>
        <div class="share-content">
          <a-select v-model="period" class="share-select">
            <a-select-option
              v-for="item in periodList"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}
            </a-select-option>
          </a-select>
        </div>
      </a-row>
      <a-row class="buttonShare">
        <a-button type="primary" @click="sandShare">{{needPwd? $t('project.copyLinkAndPassword'): $t('project.copyLink')}}</a-button>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
import Clipboard from 'clipboard'
import { Message } from 'ant-design-vue'
import { TreeSelect } from 'ant-design-vue';
const SHOW_ALL = TreeSelect.SHOW_ALL;
import {
  buildTree,
  GenerateEmailVerificationCode,
  dateSearch,
  generateId,
  decompressJson
} from '@/utils/util'
import { sandShareApi, getSandPropertyDataApi, getDictDataApi, saveSandCanvasDataApi, saveSandPropertyDataApi } from '@/api/workbench'

// 默认沙盘属性数据
const defaultSandProperty = {
  pageIndex: '9ec18c34-40ad-4400-917f-08c27889d99e',
  pageContent: 'H4sIAAAAAAAAA4uuVspLzE1VslJ6uXDry7mLDJV0lDJTgFzL1GRDi2RjE10Tg8QUXRMTAwNdS0PzNF0Di2QjcwsLyxRLy1Sg2vSi/NICoHIgMy0/JyW1KKSyAGhaWmJOcaqOUnF+UYmSlUFtLAAcCornZwAAAA==',
  layerContent: 'H4sIAAAAAAAAA4uOBQApu0wNAgAAAA=='
}

export default {
  props: {
    isShareVisible: {
      type: Boolean,
      default: false,
    },
    sandInfo: {
      type: Object,
      default: () => {}, 
    }
  },
  data() {
    return {
      SHOW_ALL,
      category: 0,
      needPwd: true,
      password: '',
      treeData: [],
      isTreeDataLoading: false,
      selected: [],
      isSelectAll: false,
      categoryList: [
        { name: 'project.canViewOnline', value: 0 },
        { name: 'project.canImportUse', value: 1 },
      ],
      period: '7',
      periodList: [
        // { name: '1天', value: 1 },
        // { name: '7天', value: 7 },
        // { name: '15天', value: 15 },
        // { name: '30天', value: 30 },
      ],
      sharePath:'',
      clipboard: null,
      sandPageTreeList: []
    }
  },
  computed: {
    // TODO
    pageIds() {
      if(this.sandPageTreeList.length){
        return this.sandPageTreeList.map((x) => x.id)
      }else{
        return []
      }
      
    },
    userId() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
      return userInfo.applyAccount || userInfo.userId || null
    },
  },
  watch: {
    isShareVisible(val) {
      if(val){
        // 从后台获取分享有效期
        this.getPeriodList()
        // 获取沙盘页面数据
        this.getSandPageData()
      }
    }
  },
  methods: {
    async getPeriodList() {
      try {
        const res = await getDictDataApi({
          dictName: "shareDays",
        })
        
        this.periodList = res.data
      } catch (error) {
        
      }
    },
    async getSandPageData(){
      try {
        const res = await getSandPropertyDataApi({
          sandId: this.sandInfo.id,
        })
        if(res.data && res.data.pageIndex) {
          this.pageIndex = res.data.pageIndex
          this.sandPageTreeList = decompressJson(res.data.pageContent)
        } else {
          // 不存在就需要创建沙盘页面数据
          this.saveSandPageData()
        }
        
      } catch (error) {
        
      }
    },
    async saveSandPageData() {
      await saveSandCanvasDataApi({
        sandId: this.sandInfo.id,
        canvasWidth: 1920,
        canvasHeight: 1080,
        canvasColor: '#282A2E4D',
        canvasBackground: '',
        pageCover: '',
      });
      await saveSandPropertyDataApi({
        sandId: this.sandInfo.id,
        pageContent: defaultSandProperty.pageContent,   // compressJson([pageIndex]),
        layerContent: defaultSandProperty.layerContent, // compressJson([]),
        pageIndex: defaultSandProperty.pageIndex,       // getId(),
      });
      this.getSandPageData()
    },
    handleCancel() {
      this.$emit('update:isShareVisible', false)
    },
    handCopy(shareCode, needPwd) {
      let path = `${ this.$t('project.sharePathName') }：${this.sandInfo.sandName}; `
      if (needPwd) path += `${ this.$t('project.sharePasswordWith') }：${this.password}; `
      path += this.period === '99999' ? `${this.$t('project.sharePermanent')}; ` : `${ this.$t('project.shareEndTime') }：${dateSearch('', 'back', this.period, 'day')}; `

      const data = btoa(
        `shareCode=${shareCode}&needPwd=${needPwd}&category=${this.category}`
      )
      // 分享的是否是沙盘的预览链接？
      const sharePath = `${process.env.VUE_APP_BICUBE_SAN_URL}/sharePreview/${data}`

      path += `${ this.$t('project.shareOnly') }${ this.$t(this.categoryList[this.category].name) }${ this.$t('project.shareSandBoxLink') }：${sharePath}`
      this.sharePath = path
      this.copyToClipboard(this.sharePath)
    },
    /**
     * 复制文本到剪贴板
     * 
     * @param {string} text - 需要复制到剪贴板的文本
     */
    copyToClipboard(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try {
            const successful = document.execCommand('copy');
            if (successful) {
              this.$message.success(this.$t('tip.copyToClipboardSuccess'))
              this.handleCancel()
            } else {
              this.$message.error(this.$t('tip.copyFailed'))
            }
        } catch (err) {
            console.error(this.$t('tip.copyError'), err);
        }
        document.body.removeChild(textarea);
    },
    async sandShare() {
      if (this.category === 1 && this.selected.length === 0) {
        Message.warning(this.$t('tip.pleaseSelectShareContent'))
        return
      }
      const result = await sandShareApi({
        sandId: this.sandInfo.id, //必填  沙盘主键id
        category: this.category, //必填 权限类型  0 可在线查看 1可导入使用
        needPwd: this.needPwd ? 1 : 0, //必填，是否启用密码 0：不启用 1 启用
        sharePwd: this.password, //密码，启用密码时必填
        period: this.period, //必填，有效期 单位：天
        account: this.userId,
        pageIds:
          this.category === 0
            ? [this.pageIndex]          //TODO 分享的页面id列表
            : this.selected, //分享的页面id列表
      })
      if (result && result.code === 200) {
        const { shareCode, needPwd } = result.data
        this.handCopy(shareCode, needPwd)
      }
    },
    onCategoryChange() {
      if (this.category === 1) {
        this.treeData = buildTree(
          this.sandPageTreeList,
          'group'
        )
      } else {
        this.selected = []
        this.isSelectAll = false
      }
    },
    handSelectTree(status) {
      // if (status) {
      //   this.selected = this.pageIds
      //   this.isSelectAll = true
      // } else {
      //   this.selected = []
      //   this.isSelectAll = false
      // }
    },
    handSelectTreeChange() {

      // if (this.pageIds.length === this.selected.length) {
        
      // } else {
        
      // }
    },
    
    handNeedPwd() {
      if (this.needPwd) {
        this.password = GenerateEmailVerificationCode()
      } else {
        this.password = ''
      }
    },
  },
  mounted() {
    if (this.needPwd) this.password = GenerateEmailVerificationCode()
  },
}
</script>

<style lang="less" scoped>
.header-checked-all{
  border-bottom: 1px solid #e8e8e8;
}
.shareSands {
  width: 100%;
  height: 100%;
  .share-select{
    width: 100%;
  }
}
.shareRow {
  // padding: 0 24px 24px 24px;
  display: flex;
  align-items: center;
  min-height: 56px;
}
.passwordRow {
  display: flex;
  align-items: center;
}
.checkboxCol {
  margin-left: 13px;
}
.buttonShare {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  // margin-right: 25px;
}
.shareTitle {
  display: flex;
  justify-content: flex-end;
  padding-right: 12px;
  width: 80px;
}
.share-content{
  flex: 1;
}

</style>
